/** Responsive workspace frame around the native DLS navigation. */

import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";

export const Frame = styled.div`
  --gtm-page-inset: ${t.space[24]};
  @media (max-width: 760px) { --gtm-page-inset: ${t.space[16]}; }
  height: 100dvh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: ${t.color.background.base};
`;
export const DesktopHeader = styled.div`
  flex-shrink: 0;
  @media (max-width: 760px) { display: none; }
`;
export const GlobalHeader = styled.div`
  display: none;
  @media (max-width: 760px) { display: block; }
`;
export const Body = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  @media (max-width: 760px) {
    flex-direction: column;
  }
`;
export const Navigation = styled.div<{ $expanded: boolean; $collapsed: boolean }>`
  width: ${({ $collapsed }) => ($collapsed ? "48px" : "224px")};
  flex-shrink: 0;
  min-height: 0;
  overflow: hidden;
  @media (max-width: 760px) {
    display: ${({ $expanded }) => ($expanded ? "flex" : "none")};
    width: 100%;
    height: 55dvh;
    max-height: 55dvh;
  }
`;
export const Island = styled.div<{ $collapsed: boolean }>`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;

`;
export const Surface = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${t.color.background.base};
`;
export const Content = styled.main<{ $fixed: boolean }>`
  flex: 1;
  min-height: 0;
  min-width: 0;
  max-width: none;
  width: 100%;
  overflow: ${({ $fixed }) => ($fixed ? "hidden" : "auto")};
  display: flex;
  flex-direction: column;
  gap: ${t.space[0]};
  padding: ${t.space[0]};
  > * {
    flex-shrink: 0;
  }

`;
